module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="item-wrapper">\n    <span class="title';
 if (action.usedBy.length) { ;
__p += ' read-only';
 } ;
__p += '"></span>\n\n    <span class="delete-icon';
 if (readOnly) { ;
__p += ' disabled';
};
__p += '"></span>\n\n    ';
 if (action.usedBy.length) { ;
__p += '\n        <span class="lock-region"></span>\n    ';
 } ;
__p += '\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/settings/integrations/customJs/CustomJsItemView.tpl
// module id = 3070
// module chunks = 0